import { DestroyRef, Directive, inject, OnInit, TemplateRef } from '@angular/core';
import { SbPageActionService } from '../../services/page-action/sb-page-action.service';

@Directive({
  selector: '[sbPageAction]',
  standalone: false,
})
export class SbPageActionDirective implements OnInit {
  private readonly pageActionService = inject(SbPageActionService);
  private readonly templateRef = inject(TemplateRef<any>);
  private readonly destroyRef = inject(DestroyRef);

  private destroyFn?: () => void;

  ngOnInit(): void {
    // Register and get cleanup function
    this.destroyFn = this.pageActionService.register(this.templateRef);

    // Auto-unregister on destroy (component/route change)
    this.destroyRef.onDestroy(() => {
      this.destroyFn?.();
    });
  }
}
